import { render, staticRenderFns } from "./ClientCreditFlag.vue?vue&type=template&id=524ee96c&scoped=true&"
import script from "./ClientCreditFlag.vue?vue&type=script&lang=js&"
export * from "./ClientCreditFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ee96c",
  null
  
)

export default component.exports